import getAxiosInstance from '@/js/axios/axios';
const antmedia = getAxiosInstance('antmedia');
const otm = getAxiosInstance('otm');

const BROADCAST = '/v2/broadcasts/';

function AntMediaRest() {
  this.stopStream = streamId => {
    return antmedia.delete(antMediaUrl(BROADCAST, streamId));
  };
  this.generateStreamId = param => {
    return otm.post('/video-room/stream', param);
  };
  this.broadcastDetailStreamInfo = streamId => {
    return antmedia.get(antMediaUrl(BROADCAST, `${streamId}/stream-info`));
  };
  this.broadcastDetail = streamId => {
    return antmedia.get(antMediaUrl(BROADCAST, streamId));
  };
  this.createBroadcast = param => {
    return antmedia.post(antMediaUrl(BROADCAST, 'create'), param);
  };
  this.streamDelete = streamId => {
    return otm.delete(antMediaUrl('/video-room/stream/', streamId.streamId));
  };
  this.roomInfo = streamId => {
    return antmedia.get(
      antMediaUrl(BROADCAST, `conference-rooms/${streamId}/room-info`),
    );
  };
  this.roomInfoAdd = (roomId, streamId) => {
    return antmedia.put(
      antMediaUrl(
        BROADCAST,
        `conference-rooms/${roomId}/add?streamId=${streamId}`,
      ),
    );
  };
}

function antMediaUrl() {
  let url = '';
  Object.keys(arguments).forEach(arg => {
    url += arguments[arg];
  });
  return url;
}

export default AntMediaRest;
